import { createWebHistory, createRouter} from 'vue-router';
import {isMobile} from "@/baseUtils";
import {authStore} from "@/store/authStore";

import BaseIframeView from "@/components/BaseIframeView.vue";
import ProposalView from "@/views/ProposalView.vue";
import ProposalCreateView from "@/views/proposal/proposal-create/ProposalCreateView.vue";
import NewsFeedView from "@/views/NewsFeedView.vue";
import AboutView from "@/views/AboutView.vue";
import PrivacyPolicyView from "@/views/PrivacyPolicyView.vue";
import UserTermsView from "@/views/UserTermsView.vue";
import CookiePolicyView from "@/views/CookiePolicyView.vue";
import BecomeManagerView from "@/views/BecomeManagerView.vue";
import ManagerLoungeView from "@/views/manager/ManagerLoungeView.vue";
import ManagerKnowledgeAreaView from "@/views/manager/ManagerKnowledgeAreaView.vue";
import ManagerView from "@/views/manager/ManagerView.vue";
import ProfileView from "@/views/profile/ProfileView.vue";
import ProfileEditView from "@/views/profile/ProfileEdit/ProfileEditView.vue";
import OrgProfileView from "@/views/profile/OrgProfileView.vue";
import ForumView from "@/views/ForumView.vue";
import MainSearchResultView from "@/components/MainSearch/MainSearchResultView.vue";
import BecomeManagerMobile from "@/mobile/BecomeManagerMobile.vue";
import SignUpView from "@/mobile/SignUpView.vue";
import ForgotPasswordView from "@/mobile/ForgotPasswordView.vue";

const router = createRouter({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: NewsFeedView,
            framePath: '/',
            meta: {
                isFrame: true
            }
        },
        {
            path: '/join',
            name: 'SignUpView',
            component: SignUpView,
            framePath: '/join'
        },
        {
            path: '/forgotpassword',
            name: 'ForgotPasswordView',
            component: ForgotPasswordView,
            framePath: '/forgotpassword'
        },
        {
            path: '/proposal/:id/:version?',
            name: 'ProposalView',
            component: ProposalView,
            framePath: '/proposal/'
        },
        {
            path: '/opinion/:id/:version?',
            name: 'OpinionView',
            component: ProposalView,
            framePath: '/opinion/'
        },
        {
            path: '/argument/:id',
            name: 'ArgumentView',
            component: ProposalView,
        },
        {
            path: '/showcreateproposal',
            name: 'ProposalCreateView',
            component: ProposalCreateView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/organization/:id',
            name: 'OrganizationView',
            component: OrgProfileView,
            framePath: '/organization/'
        },
        {
            path: '/member/:id',
            name: 'UserView',
            component: ProfileView,
        },
        {
            path: '/member/:id/editprofile',
            name: 'EditProfileView',
            component: ProfileEditView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/member/:id/:type',
            name: 'userpage',
            component: ProfileView,
        },
        {
            path: '/forum/:id',
            name: 'forum',
            component: ForumView,
            framePath: '/forum/',
            meta: {
                isFrame: true
            }
        },
        {
            path: '/search/result',
            name: 'Search',
            component: MainSearchResultView,
            framePath: '/search/result'
        },
        {
            path: '/about',
            name: 'About',
            component: AboutView,
            framePath: '/about',
            meta: {
                isFrame: true
            }
        },
        {
            path: '/privacypolicy',
            component: PrivacyPolicyView,
            framePath: '/privacypolicy',
            meta: {
                isFrame: true
            }
        },
        {
            path: '/userterms',
            component: UserTermsView,
            framePath: '/userterms',
            meta: {
                isFrame: true
            }
        },
        {
            path: '/cookiepolicy',
            component: CookiePolicyView,
            framePath: '/cookiepolicy',
            meta: {
                isFrame: true
            }
        },
        {
            name: 'ManagerView',
            path: '/manager',
            component: ManagerView,
            framePath: '/manager',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerViewOrg',
            path: '/manager/org',
            component: ManagerView,
            framePath: '/manager/org',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerViewForum',
            path: '/manager/forum',
            component: ManagerView,
            framePath: '/manager/forum',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerViewElections',
            path: '/manager/elections',
            component: ManagerView,
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerCriticalEvents',
            path: '/manager/criticalevents',
            component: ManagerView,
            framePath: '/manager/criticalevents',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerContentReviews',
            path: '/manager/contentreviews',
            component: ManagerView,
            framePath: '/manager/contentreviews',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerApplications',
            path: '/manager/applications',
            component: ManagerView,
            framePath: '/manager/applications',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerViewManagers',
            path: '/manager/managers',
            component: ManagerView,
            framePath: '/manager/managers',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerIntegration',
            path: '/manager/integration',
            component: ManagerView,
            framePath: '/manager/integration',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerUserTerms',
            path: '/manager/usertermas',
            component: ManagerView,
            framePath: '/manager/usertermas',
            meta: {
                requiresAuth: true,
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerAds',
            path: '/manager/ads',
            component: ManagerView,
            framePath: '/manager/ads',
            meta: {
                managerProfile: true,
                isFrame: true
            }
        },
        {
            name: 'ManagerProfile',
            path: '/manager/profile',
            component: ManagerView,
            framePath: '/manager/profile',
            meta: {
                requiresAuth: true,
                managerProfile: true
            }
        },
        {
            name: 'ManagerLounge',
            path: '/managerLounge',
            component: ManagerLoungeView,
            meta: {
                requiresAuth: true,
                managerProfile: true
            }
        },
        {
            path: '/managerKnowledgeArea',
            component: ManagerKnowledgeAreaView,
            framePath: '/managerKnowledgeArea',
            meta: {
                requiresAuth: true,
                isFrame: true
            }
        },
        {
            path: '/becomeManager',
            component: isMobile() ? BecomeManagerMobile : BecomeManagerView,
            framePath: '/becomeManager',
        },
        {
            path: '/:pathMatch(.*)*',
            component: BaseIframeView
        }
    ],
    history: createWebHistory()
});

router.beforeEach((to, from, next) => {
    const store = authStore();
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const authorizedUser = localStorage.getItem('authorizedUser');

    if (requiresAuth) {
        if (!authorizedUser) {
            store.toggleLoginModalState(()=> {
                next({ name: 'Index' });
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;